export const trucksOnRoadImage = require('./TrucksOnRoad.png?webp');
export const aboutUsBg = require('./about-us-bg.png?webp');
export const bgFeatureImage = require('./bgFeature.png?webp');
